/*! License details at fancyapps.com/license */
function e() {
  return !("undefined" == typeof window || !window.document || !window.document.createElement);
}
export { e as canUseDOM };